import { supabase } from "@/lib/supabase";

/**
 * Enqueue a meetup email via the `enqueue_meetup_email` RPC. The function
 * is SECURITY DEFINER so both anon and authenticated callers can use it.
 * Delivery is done by the `process-meetup-emails` cron worker.
 */
export async function enqueueMeetupEmail(args: {
  eventId: string;
  toEmail: string;
  toName?: string;
  emailType: string;
  payload?: Record<string, unknown>;
  sendAt?: Date;
  participantId?: string;
}): Promise<void> {
  const { error } = await supabase.rpc("enqueue_meetup_email", {
    p_event_id: args.eventId,
    p_to_email: args.toEmail,
    p_to_name: args.toName ?? null,
    p_email_type: args.emailType,
    p_payload: args.payload ?? {},
    p_send_at: (args.sendAt ?? new Date()).toISOString(),
    p_participant_id: args.participantId ?? null,
  });
  if (error) {
    // Non-blocking — log but don't interrupt the user's action.
    console.warn(`enqueue_meetup_email failed (${args.emailType}):`, error.message);
  }
}

export function meetupEventUrl(slug: string): string {
  return `https://meetup.finally.plus/e/${slug}`;
}

export function formatMeetupDate(iso: string): string {
  return new Date(iso).toLocaleString("en-US", {
    weekday: "short",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}
